import IframeAttr from "@elements/ArticleParagraph/Embeds/helper/IframeAttr";
import SocialEmbedFactory from "@elements/ArticleParagraph/Embeds/helper/SocialEmbedFactory";
import Iframe from "@elements/Iframe/Iframe";

export default function Embed({
  src,
  className,
}: {
  src: string;
  className?: string;
}): React.ReactElement {
  const SocialEmbed = SocialEmbedFactory(src);
  const iframeAttr = IframeAttr(src);

  return (
    <div className={className} data-testid="embed-component">
      {SocialEmbed ? <SocialEmbed url={src} /> : <Iframe {...iframeAttr} />}
    </div>
  );
}
